var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pay-success-page"},[_vm._v(" pay_success ")])
}
var staticRenderFns = []

export { render, staticRenderFns }